/* eslint-disable import/prefer-default-export */
import { createMutation } from 'react-query-kit';
import { AxiosError } from 'axios';
import { axios } from '..';

type Variables = {
  id: string;
  payload: {
    firstName: string;
    lastName: string;
    gender: string;
    email: string;
  };
};
export const useAddStudent = createMutation<any, Variables, AxiosError>({
  mutationFn: async (variables) =>
    axios
      .post(`/School/students/new_student/${variables.id}`, variables.payload)
      .then((response) => response.data)
});
